// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 30px;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    width: 500px;
    max-width: 90%;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-content h2 {
    margin: 0 0 20px 0;
    color: #2c3e50;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
}

.form-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.form-group label {
    margin-bottom: 8px;
    color: #34495e;
    font-weight: 500;
    font-size: 14px;
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group select {
    padding: 10px 12px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.form-group input[type="text"]:focus,
.form-group input[type="number"]:focus,
.form-group select:focus {
    border-color: #409eff;
    outline: none;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.form-group.checkbox-group {
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.form-group input[type="checkbox"] {
    width: 18px;
    height: 18px;
    margin: 0;
    cursor: pointer;
}

.modal-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 30px;
}

.save-button,
.cancel-button {
    padding: 10px 20px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.save-button {
    background-color: #409eff;
    color: white;
    border: none;
}

.save-button:hover {
    background-color: #66b1ff;
}

.save-button:active {
    background-color: #3a8ee6;
}

.cancel-button {
    background-color: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
}

.cancel-button:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}

.price-input {
    position: relative;
}

.price-input::after {
    content: '\$';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-100%);
    color: #909399;
}

/* Стили для скроллбара */
.modal-content::-webkit-scrollbar {
    width: 8px;
}

.modal-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
    background: #909399;
} `, "",{"version":3,"sources":["webpack://./src/components/Admin/AddPlanModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;;IAGI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;;;IAGI,qBAAqB;IACrB,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,4BAA4B;IAC5B,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    padding: 30px;\n    border-radius: 12px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n    width: 500px;\n    max-width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.modal-content h2 {\n    margin: 0 0 20px 0;\n    color: #2c3e50;\n    font-size: 24px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.form-group {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group label {\n    margin-bottom: 8px;\n    color: #34495e;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group select {\n    padding: 10px 12px;\n    border: 1px solid #dcdfe6;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: border-color 0.2s;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"number\"]:focus,\n.form-group select:focus {\n    border-color: #409eff;\n    outline: none;\n    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);\n}\n\n.form-group.checkbox-group {\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n}\n\n.form-group input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    margin: 0;\n    cursor: pointer;\n}\n\n.modal-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 30px;\n}\n\n.save-button,\n.cancel-button {\n    padding: 10px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.save-button {\n    background-color: #409eff;\n    color: white;\n    border: none;\n}\n\n.save-button:hover {\n    background-color: #66b1ff;\n}\n\n.save-button:active {\n    background-color: #3a8ee6;\n}\n\n.cancel-button {\n    background-color: #fff;\n    color: #606266;\n    border: 1px solid #dcdfe6;\n}\n\n.cancel-button:hover {\n    color: #409eff;\n    border-color: #c6e2ff;\n    background-color: #ecf5ff;\n}\n\n.price-input {\n    position: relative;\n}\n\n.price-input::after {\n    content: '$';\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-100%);\n    color: #909399;\n}\n\n/* Стили для скроллбара */\n.modal-content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.modal-content::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.modal-content::-webkit-scrollbar-thumb {\n    background: #c0c4cc;\n    border-radius: 4px;\n}\n\n.modal-content::-webkit-scrollbar-thumb:hover {\n    background: #909399;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
